import React from 'react';
import { UnsubscribersListItem } from 'services/apiService';
import { useLoaderData } from 'react-router-dom';
import { Await } from 'react-router-dom';
import { CircularProgress, Box, Typography, Menu } from '@mui/material';
import { useAsyncValue } from 'react-router-dom';
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import PersonIcon from "@mui/icons-material/Person";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Checkbox from "@mui/material/Checkbox";
import Paper from '@mui/material/Paper';
import { useState } from 'react';
import { useFetcher } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { ListChildComponentProps } from 'react-window';
import { useMemo } from 'react';
import { useCallback } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList } from 'react-window';
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from '@mui/material/MenuItem';
import { LoadingButton } from '@mui/lab';
import DeleteIcon from '@mui/icons-material/Delete';
import Button from "@mui/material/Button";


const UnsubListItem = (
    {
        contact,
        checked,
        handleCheckedToggle
    }: {
        contact: UnsubscribersListItem;
        checked: boolean;
        handleCheckedToggle: (contactId: string) => void;
    }
) => {

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const fetcher = useFetcher();
    const { enqueueSnackbar } = useSnackbar();
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const [isHovering, setIsHovering] = useState(false);
    const handleMouseOver = () => {
        setIsHovering(true);
    };
    const handleMouseOut = () => {
        setIsHovering(false);
    };

    const isActive = (contact.isActive) ? "Active" : "Non active"

    // useEffect(() => {
    //     if (fetcher.data) {
    //     if (fetcher.data.success === true) {
    //         switch (fetcher.data.action) {
    //         case AddressBookDetailsFormAction.DeleteContacts:
    //             enqueueSnackbar("Contacts deleted successfully!", {
    //             variant: "success",
    //             });
    //             break;

    //         default:
    //             break;
    //         }
    //     } else {
    //         enqueueSnackbar(fetcher.data.error, { variant: "error" });
    //     }

    //     }
    // }, [fetcher.data, enqueueSnackbar]);
    return (
        <>
            <ListItem
                disablePadding
                component={Paper}
                variant="outlined"
                secondaryAction={
                    <IconButton aria-label="more">
                        <MoreHorizIcon fontSize="inherit" />
                    </IconButton>
                }
            >
                <ListItemButton
                    onMouseOver={handleMouseOver}
                    onMouseOut={handleMouseOut}
                    onClick={() => handleCheckedToggle(contact.value)}
                >
                    <ListItemIcon>
                        {isHovering || checked ? (
                            <Checkbox
                                edge="start"
                                checked={checked}
                                tabIndex={-1}
                                disableRipple
                                inputProps={{ "aria-labelledby": contact.value }}
                            />
                        ) : (
                            <PersonIcon style={{ color: '#226CE6 ' }} />
                        )}
                    </ListItemIcon>

                    <ListItemText
                        primary={
                            <Typography variant="inherit" noWrap>
                                {contact.value}
                            </Typography>
                        }
                        secondary={
                            <Typography variant="inherit" noWrap>
                                {isActive}
                            </Typography>
                        }

                    />
                </ListItemButton>
            </ListItem>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {/* <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <DeleteIcon />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem> */}
                <MenuItem>
                    <fetcher.Form method="delete" id="deleteAddressBookForm">
                        <LoadingButton
                            aria-label="delete"
                            type="submit"
                            form="deleteAddressBookForm"
                            startIcon={<DeleteIcon />}
                            loading={fetcher.state === "submitting"}
                            color="error"
                        >
                            Delete
                        </LoadingButton>
                        {/* <input
                            type="hidden"
                            name="action"
                            value={AddressBookDetailsFormAction.DeleteContacts}
                        /> */}
                        <input
                            type="hidden"
                            name="type"
                            value={contact.type}
                        />
                        <input
                            type="hidden"
                            name="value"
                            value={contact.value}
                        />
                    </fetcher.Form>
                </MenuItem>
            </Menu>
        </>

    )
}

const buildContactRowRenderer = ({
    checkedContactIds,
    handleCheckedToggle,
}: {
    checkedContactIds: string[];
    handleCheckedToggle: (value: string) => void;
}) => {
    return ({
        data,
        index,
        style,
    }: ListChildComponentProps<UnsubscribersListItem[]>) => {
        const contact = data[index];

        return (
            <div key={contact.value} style={style}>
                <UnsubListItem
                    contact={contact}
                    checked={checkedContactIds.indexOf(contact.value) !== -1}
                    handleCheckedToggle={handleCheckedToggle}
                />
            </div>
        );
    };
};

const ContactList = (
    {
        contacts,
        checkedContactIds,
        handleCheckedToggle
    }: {
        contacts: UnsubscribersListItem[];
        checkedContactIds: string[];
        handleCheckedToggle: (contactId: string) => void;
    }
) => {
    // console.log("contacts : ", contacts)
    const renderContactRow = useMemo(
        () =>
            buildContactRowRenderer({
                checkedContactIds,
                handleCheckedToggle: handleCheckedToggle,
            }),
        [checkedContactIds, handleCheckedToggle]
    );

    return contacts.length > 0 ? (
        <div style={{ display: "flex", flexGrow: 1 }} className="contact-list">
            <div style={{ flex: "1 1 auto" }}>
                <AutoSizer>
                    {({ height, width }) => (
                        <FixedSizeList
                            height={height}
                            width={width}
                            itemSize={88}
                            itemCount={contacts.length}
                            itemData={contacts}
                        >
                            {renderContactRow}
                        </FixedSizeList>
                    )}
                </AutoSizer>
            </div>
        </div>
    ) : (
        <div>No contacts</div>
    );
}

const Unsubs = () => {
    const unsubscriberList = useAsyncValue() as UnsubscribersListItem[]
    console.log("unsubscribers : ", unsubscriberList)

    const [searchText, setSearchText] = useState("");
    const filteredContacts = useMemo(() => {
        if (searchText.length === 0) return unsubscriberList;

        return unsubscriberList.filter((contact) =>
            contact.value
                .toLocaleLowerCase()
                .includes(searchText.toLocaleLowerCase())
        );
    }, [unsubscriberList, searchText]);

    console.log("** filteredContacts : ", filteredContacts)
    const fetcher = useFetcher();

    const [checkedContactIds, setCheckedContactIds] = useState<string[]>([]);
    const handleCheckedToggle = useCallback(
        (contactId: string) => {
            const currentIndex = checkedContactIds.indexOf(contactId);
            const newChecked = [...checkedContactIds];

            if (currentIndex === -1) {
                newChecked.push(contactId);
            } else {
                newChecked.splice(currentIndex, 1);
            }

            setCheckedContactIds(newChecked);
        },
        [checkedContactIds, setCheckedContactIds]
    );

    return (
        <>
            <Stack
                sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                }}
                spacing={4}
            >
                <Grid container alignItems="center" rowSpacing={2}>
                    <Grid item xs={12} md={8}>
                        <TextField
                            value={searchText}
                            onChange={(event) => setSearchText(event.target.value)}
                            placeholder="Search"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            fullWidth
                        />
                    </Grid>
                </Grid>

                <ContactList
                    contacts={filteredContacts}
                    checkedContactIds={checkedContactIds}
                    handleCheckedToggle={handleCheckedToggle}
                />

                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <div>{checkedContactIds.length} selected</div>

                    <Button
                        variant="text"
                        sx={{ mx: 2 }}
                        onClick={() => setCheckedContactIds([])}
                    >
                        Unselect all
                    </Button>

                    <Box
                        sx={{
                            flexGrow: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "end",
                        }}
                    >
                        <fetcher.Form method="delete">
                            {/* <input
                                type="hidden"
                                name="action"
                                value={AddressBookDetailsFormAction.DeleteContacts}
                            /> */}

                            <input
                                type="hidden"
                                name="contact_ids"
                                value={checkedContactIds.join(",")}
                            />

                            <IconButton
                                disabled={checkedContactIds.length === 0}
                                aria-label="delete"
                                type="submit"
                            >
                                <DeleteIcon />
                            </IconButton>
                        </fetcher.Form>
                    </Box>
                </Box>

            </Stack>
        </>
    )
}

const Unsubscribers = () => {
    const loaderdata = useLoaderData() as {
        unsubscribers: Promise<UnsubscribersListItem[]>
    }

    return (
        <React.Suspense
            fallback={
                <Box
                    sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress />
                    <p>Fetching Unsubscribers...</p>
                </Box>
            }
        >
            <Await
                resolve={loaderdata.unsubscribers}
                errorElement={<p>Error while loading unsubscribers data</p>}
            >
                <Unsubs />
            </Await>
        </React.Suspense>
    );
};

export default Unsubscribers;